import React from 'react'
import style from './RowWithMenu.module.scss'
import cn from 'classnames'

const RowWithMenu = ({ children, selected, rowMenu, data }) => {
	const shouldShowMenu = (typeof selected === 'undefined' || selected) && rowMenu.length
	const menuItems = []
	rowMenu.forEach(({ func, Icon }, i) => {
		menuItems.push(<Icon key={i} onClick={() => func(data.id)}/>)
		if(i !== rowMenu.length - 1) {
			menuItems.push(<div key={`delimiter ${i}`}/>)
		}
	})
	return(
		<div className={cn('rt-tr-group', style.root)} role='rowgroup'>
			{children}
			{shouldShowMenu &&
				<React.Fragment>
					<div className={style['root-menu']}>
						{menuItems}
					</div>
					<div className={style['root-btn']}>
					...
					</div>
				</React.Fragment>
			}
		</div>
	)
}
export default RowWithMenu
